import { useState } from "react";

import { medidasDoIngrediente } from "../lib/unidades";

// Formulário de um item. Por dentro guarda tudo na unidade do estoque; os campos
// (pacotes, unidades, preço por pacote, preço por unidade e total) são vistas da
// mesma compra e se completam entre si. `fonte` diz qual valor de dinheiro a
// pessoa digitou por último, pra saber o que recalcular quando a quantidade muda.
export default function useLancamento(porId) {
  const [ingId, setIngId] = useState("");
  const [qtd, setQtd] = useState(null); // na unidade do estoque
  const [preco, setPreco] = useState(null); // por unidade do estoque
  const [total, setTotal] = useState(null);
  const [fonte, setFonte] = useState("preco");

  const ing = porId.get(ingId) || null;
  const medidas = medidasDoIngrediente(ing);

  const limpar = () => { setIngId(""); setQtd(null); setPreco(null); setTotal(null); setFonte("preco"); };
  const escolher = (id) => { setIngId(id); setQtd(null); setPreco(null); setTotal(null); setFonte("preco"); };

  const mudarQtd = (medida, v) => {
    const q = v == null ? null : v * medida.fator;
    setQtd(q);
    if (!(q > 0)) return;
    if (fonte === "total" && total != null) setPreco(total / q);
    else if (preco != null) setTotal(preco * q);
  };

  const mudarPreco = (medida, v) => {
    const p = v == null ? null : v / medida.fator;
    setPreco(p);
    setFonte("preco");
    if (p != null && qtd > 0) setTotal(p * qtd);
  };

  const mudarTotal = (v) => {
    setTotal(v);
    setFonte("total");
    if (v != null && qtd > 0) setPreco(v / qtd);
  };

  const carregar = (item) => {
    setIngId(item.ingredient_id);
    setQtd(item.qtdEstoque);
    // Corrigir a quantidade de um item mantém o preço unitário e refaz o total.
    setPreco(item.qtdEstoque > 0 ? item.total / item.qtdEstoque : null);
    setTotal(item.total);
    setFonte("preco");
  };

  const naMedida = (medida) => (qtd == null ? null : qtd / medida.fator);
  const precoNaMedida = (medida) => (preco == null ? null : preco * medida.fator);

  const valido = !!ing && qtd > 0 && total > 0;
  const item = () => ({ ingredient_id: ing.id, nome: ing.name, qtdEstoque: qtd, total: Math.round(total * 100) / 100 });

  return { ing, ingId, medidas, qtd, preco, total, valido, escolher, mudarQtd, mudarPreco, mudarTotal, naMedida, precoNaMedida, carregar, limpar, item };
}
